/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentProcedureSimulationsNewRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations/new';

export default AutomationFinAIAgentProcedureSimulationsNewRoute;
